import React, { useState } from "react";
import { connect } from "react-redux";
import { LuCheck } from "react-icons/lu";
import { RxCross2 } from "react-icons/rx";
import { Button, Form, Spinner } from "react-bootstrap";

import {
  emptyString,
  roleTypeEnums,
  inboxReduxConstants,
  loginConstants,
  LoginRoles,
} from "../../../constants";
import { inboxActions } from "../../../redux/actions";
import { UTCToDateFormat, handleAsyncAction } from "../../../../../shared";
import { getItemFromStorage } from "../../../../../system";

const InternalNotesComponent = ({
  user,
  spinner,
  saveInternalNotes,
  selectedConversation,
  previousInternalNotes,
  getPreviousInternalNotes,
}) => {
  const userRole = getItemFromStorage(loginConstants.ROLE);

  const [note, setNote] = useState(emptyString);
  const [showAddNote, setShowAddNote] = useState(false);

  const isSuperAdmin =
    user.roleId === roleTypeEnums.SUPER_ADMIN ||
    userRole === LoginRoles.SUPER_ADMIN;

  const handleAddNote = () => {
    handleAsyncAction(
      saveInternalNotes({
        customerConversationId: selectedConversation.id,
        notesMessage: note,
        addedBy: user.name,
        systemUserId: user.id,
      }),
      {
        onSuccess: () => {
          setNote(emptyString);
          setShowAddNote(false);
          getPreviousInternalNotes(selectedConversation.orderId);
        },
      },
    );
  };

  return (
    <div
      className="previous-internal-notes custome-sidebar"
      data-testid="internal-notes-div"
    >
      {spinner(inboxReduxConstants.GET_PREVIOUS_INTERNAL_NOTES) ? (
        <div className="h-100 d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="dark" role="status" />
        </div>
      ) : (
        <>
          <div className="p-2 text-center border-1 border-bottom">
            {showAddNote ? (
              <div>
                <Form.Control
                  rows={3}
                  type="text"
                  value={note}
                  as="textarea"
                  name="internalNotes"
                  placeholder="type note here..."
                  className="custome-sidebar w-100"
                  onChange={({ target: { value } }) => setNote(value)}
                  disabled={
                    spinner(inboxReduxConstants.SAVE_INTERNAL_NOTES)
                  }
                />
                <div className="d-flex gap-2 pt-2 justify-content-end">
                  <Button
                    size="sm"
                    variant="danger"
                    title="cancel"
                    onClick={() => {
                      setShowAddNote(false);
                      setNote(emptyString);
                    }}
                  >
                    <RxCross2 size={15} />
                  </Button>
                  <Button
                    size="sm"
                    variant="success"
                    disabled={!note}
                    title="add note"
                    onClick={handleAddNote}
                  >
                    <LuCheck size={15} />
                  </Button>
                </div>
              </div>
            ) : (
              <Button
                size="sm"
                onClick={() => setShowAddNote(true)}
                disabled={isSuperAdmin}
                className="fw-bold green-background-color green-border"
              >
                ADD NOTE
              </Button>
            )}
          </div>
          {previousInternalNotes?.length > 0 ? (
            previousInternalNotes.map((note) => (
              <div
                className="border-1 border-bottom p-2"
                key={note.id}
                data-testid="internal-notes"
              >
                <div className="d-flex justify-content-between align-items-end">
                  <p className="fw-bold text-break mb-0">{note.addedBy}</p>
                  <div>
                    <small className="fw-bold">
                      {UTCToDateFormat(note.updatedAt)}
                    </small>
                  </div>
                </div>
                <p className="mb-0 py-2 text-break text-secondary">
                  {note.notesMessage}
                </p>
              </div>
            ))
          ) : (
            <p className="p-2 m-0 text-center">No internal notes added yet!</p>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  previousInternalNotes: state.inboxReducer.conversation.previousInternalNotes,
});

const mapDispatchToProps = (dispatch) => ({
  saveInternalNotes: (data, toastDisplayFlag) =>
    dispatch(inboxActions.saveInternalNotes(data, toastDisplayFlag)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(InternalNotesComponent));
